'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btnStyle = {
	backgroundImage: 'url("https://www.paypalobjects.com/webstatic/mktg/consumer/onboarding/ui-sprite.png")',
	backgroundPosition: '-27px -3486px',
	minWidth: 27,
	padding: '9px 20px',
	margin: '1rem'
};

var STYLES = {
	audio: {
		marginTop: '1rem',
		width: '100%'
	},
	audioBtn: Object.assign({}, btnStyle, {
		backgroundPosition: '-27px -3486px'
	}),
	refreshBtn: Object.assign({}, btnStyle, {
		backgroundPosition: '-27px -3386px'
	}),
	form: {
		border: '1px solid rgb(157, 163, 166)',
		borderRadius: 5,
		margin: '0 auto',
		maxWidth: 500,
		padding: 35,
		textAlign: 'center',
		width: '100%'
	},
	captchaImage: {
		border: '1px solid rgb(203, 210, 214)',
		borderRadius: 5,
		marginBottom: '1rem',
		padding: '1rem'
	}
};

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		maxWidth: 315,
		margin: '0 auto',
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

var Captcha = _react2.default.createClass({
	displayName: 'Captcha',

	propTypes: {
		captchaObject: _react.PropTypes.shape({
			captchaImgUrl: _react.PropTypes.string.isRequired,
			captchaAudioUrl: _react.PropTypes.string.isRequired
		}).isRequired,

		verifyContent: _react.PropTypes.string,
		submitContent: _react.PropTypes.string,
		textInputLabel: _react.PropTypes.string,
		refreshContent: _react.PropTypes.string,
		toggleAudioContent: _react.PropTypes.string,
		errorMessage: _react.PropTypes.string,
		showErrorMessage: _react.PropTypes.bool,

		refreshCaptcha: _react.PropTypes.func.isRequired,
		submitAnswer: _react.PropTypes.func.isRequired,
		handleCaptchaBlur: _react.PropTypes.func.isRequired,
		updateAnswer: _react.PropTypes.func.isRequired
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleCaptchaBlur: function handleCaptchaBlur() {},
			updateAnswer: function updateAnswer() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			showAudio: false,
			answer: ''
		};
	},
	toggleAudio: function toggleAudio() {
		this.setState({
			showAudio: !this.state.showAudio
		});
	},
	updateAnswer: function updateAnswer(answer) {
		this.props.updateAnswer(answer);
		this.setState({ answer: answer });
		return answer;
	},
	submitAnswer: function submitAnswer(event) {
		event.preventDefault();
		this.props.submitAnswer(this.state.answer);
	},
	render: function render() {
		var _props = this.props,
		    verifyContent = _props.verifyContent,
		    submitContent = _props.submitContent,
		    textInputLabel = _props.textInputLabel,
		    refreshContent = _props.refreshContent,
		    toggleAudioContent = _props.toggleAudioContent,
		    _props$errorMessage = _props.errorMessage,
		    errorMessage = _props$errorMessage === undefined ? '' : _props$errorMessage,
		    _props$showErrorMessa = _props.showErrorMessage,
		    showErrorMessage = _props$showErrorMessa === undefined ? false : _props$showErrorMessa,
		    handleCaptchaBlur = _props.handleCaptchaBlur;
		var _props$captchaObject = this.props.captchaObject,
		    captchaImgUrl = _props$captchaObject.captchaImgUrl,
		    captchaAudioUrl = _props$captchaObject.captchaAudioUrl;


		var captchaWrapperClassNames = (0, _classnames2.default)({
			'vx_has-error-with-message': errorMessage && showErrorMessage
		});

		var captchaAudioClass = this.state.showAudio ? '' : 'hide';

		return _react2.default.createElement(
			'form',
			{ onSubmit: this.submitAnswer, style: STYLES.form },
			_react2.default.createElement(
				'h2',
				null,
				verifyContent
			),
			_react2.default.createElement('img', { style: STYLES.captchaImage, src: captchaImgUrl }),
			_react2.default.createElement(
				'div',
				{ className: captchaWrapperClassNames, style: { margin: '10px 0' } },
				_react2.default.createElement(_reactTextInput2.default, {
					name: 'captchaImage',
					id: 'captchaImage',
					className: 'vx_form-control vx_form-control_complex',
					label: textInputLabel,
					required: true,
					value: this.state.answer,
					handleChange: this.updateAnswer,
					handleBlur: handleCaptchaBlur }),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, errorMessage && styles.errorShown), {
							'vx_form-control-message': errorMessage
						}) },
					errorMessage
				)
			),
			_react2.default.createElement(
				'audio',
				{ id: 'captchaAudio',
					controls: 'controls',
					src: captchaAudioUrl,
					className: captchaAudioClass,
					style: STYLES.audio },
				_react2.default.createElement('embed', { height: '50', width: '100', src: captchaAudioUrl })
			),
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: 'vx_btn vx_btn-secondary btn refresh', style: STYLES.refreshBtn, title: refreshContent, onClick: this.props.refreshCaptcha },
					'\xA0'
				),
				_react2.default.createElement(
					'div',
					{ className: 'vx_btn vx_btn-secondary btn audio', style: STYLES.audioBtn, title: toggleAudioContent, onClick: this.toggleAudio },
					'\xA0'
				)
			),
			_react2.default.createElement(
				'button',
				{ className: 'vx_btn' },
				submitContent
			)
		);
	}
});

exports.default = Captcha;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Captcha.js
// module id = 816
// module chunks = 5